// extracted by mini-css-extract-plugin
module.exports = {"navLink":"InternalHeaderLinks_navLink__12ImX","anchorLink":"InternalHeaderLinks_anchorLink__3BghT","active":"InternalHeaderLinks_active__2iFXu"};